module.exports = "/_next/static/images/shield-monotone-b24ee08b5a64ed2e50872dc2102cff14.svg";